<template>
    <v-container grid-list-lg style="max-width: 1240px" class="py-0">

        <v-form ref="form" pt-4>
            <v-layout row wrap align-end>
                <v-flex xs12 sm6 md4 py-0>
                    <v-checkbox
                        style="margin-top: 0px; height: 25px;"
                        v-model="hasOldLastName"
                        label="Менялась фамилия"
                    />
                    <osago-name
                        v-model="lastName"
                        label="Фамилия"
                    />
                </v-flex>
                <v-flex xs12 sm6 md4 py-0 style="align-self: flex-end"
                        v-if="hasOldLastName"
                >
                    <osago-name
                        v-model="oldLastName"
                        label="Старая фамилия"
                    />
                </v-flex>
                <v-flex xs12 sm6 md4 py-0>
                    <osago-name
                        v-model="firstName"
                        label="Имя"
                    />
                </v-flex>
                <v-flex xs12 sm6 md4 py-0>
                    <osago-name
                        v-model="middleName"
                        label="Отчество"
                        optional="true"
                        genitiveLabel="отчества"
                        :noField.sync="noMiddleName"
                    />
                </v-flex>
                <v-flex xs12 sm6 md4 py-0
                        style="align-self: flex-end"
                >
                    <osago-date
                        v-model="birthday"
                        :max="maxBirthdate"
                        label="Дата рождения"
                    />
                </v-flex>
                <v-flex xs12 sm6 md4 py-0>
                    <v-checkbox
                        style="margin-top: 0px; height: 25px;"
                        v-model="hasOld"
                        label="Есть старые права"
                    />
                    <v-text-field
                        v-model="license"
                        :label="(hasOld ? 'Новые права' : 'Права') + ': серия и номер'"
                        :rules="[rules.required, rules.license]"
                        @paste="removeSpacesOnPaste($event, license)"
                        mask="##SS ######"
                        return-masked-value
                        validate-on-blur
                    />
                </v-flex>
                <v-flex xs12 sm6 md4 py-0
                        v-if="hasOld"
                >
                    <v-text-field
                        v-model="oldLicense"
                        label="Старые права: серия и номер"
                        :rules="[rules.required,rules.license,noEquilSeriesNumber]"
                        @paste="removeSpacesOnPaste($event, oldLicense)"
                        mask="##SS ######"
                        return-masked-value
                        validate-on-blur
                    />
                </v-flex>
                <v-flex xs12 sm6 md4 py-0>
                    <osago-date
                        v-model="kbmdate"
                        :max="today"
                        label="Дата запроса"
                    />
                </v-flex>
            </v-layout>

            <v-layout pt-4 row wrap v-if="!hasResult">
                <v-flex xs12 sm6>
                    <v-btn @click="validate(submit)"
                            :loading="loading"
                            class="next-button button">Проверить КБМ</v-btn>
                </v-flex>
            </v-layout>

            <services-kbm-result
                v-if="hasResult"
                :result="requestResult"
            />

            <v-layout pt-4 row wrap v-if="hasResult">
                <v-flex pt-4>
                    <h3>Внимание! Восстановление КБМ может занимать от 12 часов до 7 дней.</h3>
                </v-flex>
            </v-layout>

            <v-layout pt-4 row wrap v-if="hasResult">
                <v-flex xs12 sm6 md4>
                    <file-upload-field
                        :validation="imageValidation"
                        @getImg="getImg"
                        @removeImg="removeImg"
                    />
                </v-flex>
                <v-flex xs12 sm6 md4>
                    <v-flex>
                        <v-btn
                            @click="validate(submitRecoveryPayment)"
                            :loading="loading"
                            class="next-button button">Восстановить КБМ за 150₽</v-btn>
                    </v-flex>
                    <v-flex>
                        <div class="policy-wrapper">
                            Отправляя анкету, соглашаюсь
                            <br>с <a class="policy" target="_blank" href="https://getpolis.ru/osago_policy">политикой
                            обработки персональных данных</a>
                            <br>и даю 
                                <a class="policy" target="_blank" href="https://getpolis.ru/soglasie_pdn">
                                    Согласие на обработку персональных данных
                                </a>
                        </div>
                    </v-flex>
                </v-flex>
                <v-flex xs12 sm6 md4>
                    <kbm-links/>
                </v-flex>
            </v-layout>
        </v-form>
    </v-container>
</template>
<script>
    import helperMixin from '../../mixins/helper';
    import moment from 'moment';

    export default {
        mixins: [helperMixin],
        props: ['hasResult', 'requestResult', 'loading'],
        data: () => ({
            lastName: null,
            hasOldLastName: false,
            oldLastName: null,
            firstName: null,
            middleName: null,
            birthday: null,
            license: null,
            oldLicense: null,
            hasOld: false,
            kbmdate: null,
            image: null,
            maxBirthdate: null,
            today: null,
            isRestoreKbm: false,
            noMiddleName: false,
            noEquilSeriesNumber: true,
            imageValidation: true,

            rules: {
                required: v => !!v || 'Обязательное поле',
                license: v => /^\d{2}[\dА-ЯA-Z]{2} \d{6}$/.test(v) || 'Неверный формат',
            }
        }),

        mounted: function(){
            this.today = moment().format('YYYY-MM-DD')
            this.maxBirthdate =  moment().subtract(16, 'years').format('YYYY-MM-DD')
            this.kbmdate = this.today
        },

        methods: {
            validate(successFunc) {
                if (this.$refs.form.validate() && this.validateImage()) {
                    this.firstName = this.firstName ? this.firstName.trim() : '';
                    this.lastName = this.lastName ? this.lastName.trim() : '';
                    this.middleName = this.middleName ? this.middleName.trim() : '';
                    successFunc();
                } else {
                    this.$nextTick(function () {
                        PNotify.error('Проверьте правильность выделенных полей.');
                        this.goToFirstError();
                    });
                }
            },

            validateImage() {
                if (!this.hasResult) {
                    return true
                }
                if (!this.image) {
                    this.imageValidation = false
                    return false
                }
                this.imageValidation = true
                return true
            },

            prepareData() {
                return {
                    firstName: this.firstName,
                    lastName: this.lastName,
                    hasOldLastName: this.hasOldLastName,
                    oldLastName: this.oldLastName,
                    middleName: this.middleName,
                    noMiddleName: this.noMiddleName,
                    birthday: this.birthday,
                    license: this.license,
                    oldLicense: this.hasOld ? this.oldLicense : '',
                    kbmdate: this.kbmdate ? this.kbmdate : '',
                    image: this.image,
                    isRestoreKbm: this.isRestoreKbm
                }
            },

            submit() {
                this.$emit('find', this.prepareData())
            },

            submitRecoveryPayment() {
                PNotify.info('Нужно оплатить, но вы не можете оплатить');
            },

            getImg(data) {
                this.imageValidation = true
                this.image = data
            },

            removeImg() {
                this.image = null
            },

            goToFirstError() {
                this.$vuetify.goTo('.error--text', {
                    duration: 600,
                    offset: 150,
                    easing: 'easeInCubic',
                });
            },

            inputOldLicenseNumber(event, license) {
                this.noEquilSeriesNumber = event == license ? 'Не может совпадать с номером новых прав' : true;
            },
        }
    }
</script>
<style scoped>
    h3 {
        font-size: 20px;
        font-family: 'SFProBold'
    }
</style>



// WEBPACK FOOTER //
// resources/js/components/services/ServicesKbmRequestForm.vue